document.addEventListener('DOMContentLoaded', () => {
  const cartForm = document.querySelector('.cart-form');
  if (!cartForm) return;

  const redElement = cartForm.querySelector('.red');
  const buttonElement = cartForm.querySelector('.button');
  const textareaElement = cartForm.querySelector('.textarea');
  const vinInput = document.getElementById('vin_attribute');
  const vinSkipCheckbox = document.getElementById('vin_skip_checkbox');

  if (vinInput && vinSkipCheckbox) {
    const updateVinRequired = () => {
      if (vinSkipCheckbox.checked) {
        vinInput.removeAttribute('required');
        vinInput.setCustomValidity('');
      } else {
        vinInput.setAttribute('required', '');
      }
    };

    vinSkipCheckbox.addEventListener('change', updateVinRequired);
    updateVinRequired();
  }

  if (redElement && buttonElement && textareaElement && buttonElement.disabled) {
    textareaElement.addEventListener('input', (event) => {
      const { value } = event.target;

      if (value.length >= 17) {
        redElement.style.display = 'none';
        buttonElement.removeAttribute('disabled');
      } else {
        redElement.style.display = 'block';
        buttonElement.setAttribute('disabled', 'true');
      }
    });
  }
});